import { ElementType } from 'react';

export const RegisteredInteractiveHtmlElements = {
  A: 'a',
  BUTTON: 'button',
  LABEL: 'label',
} as const satisfies Record<string, ElementType>;

export type RegisteredInteractiveHtmlElements = Union<
  typeof RegisteredInteractiveHtmlElements
>;
